import React from 'react';

export const Mobile: React.FC<React.PropsWithChildren> = ({children}) => {
    return (
        <div className="tablet:hidden">{children}</div>
    )
}
